import React, { useEffect, useState } from "react";
import brandLogo from "../../assets/logo/brandLogo.png";
import { Link, useLocation } from "react-router-dom";
import * as config from "../../api/config";
import * as Url from "../../Service/Url";
import toastFile from "../../Service/ToastFile";
import GoogleIcon from "../../assets/logo/GoogleIcon";

const Login = ({ navigate }) => {
  const location = useLocation();

  useEffect(() => {
    if (location?.state !== null) {
      toastFile("email not match");
    }
  }, []);

  return (
    <>
      <nav
        className="navbar bg-body-tertiary pe-4 py-3"
        style={{ borderBottom: "1px solid #efefef" }}
      >
        <div className="container-fluid">
          <Link to={"/"} className="navbar-brand d-flex align-items-start ps-1">
            <img
              src={brandLogo}
              width="260"
              alt="logo"
              className="img-fluid me-2"
            />
            {/* <div className="fs-4 Gotham-Black">Infused Analytics</div> */}
          </Link>
          <div className="d-flex gap-4 align-items-center">
            {/* <button className="primary-button ms-4 py-2 px-4">Admin</button> */}
          </div>
        </div>
      </nav>
      <div
        style={{
          height: "90vh",
          width: "15%",
          borderRight: "1px solid #efefef ",
          marginTop: 10,
        }}
        className="d-md-block d-none"
      ></div>
      <div className="modal d-flex flex-column justify-content-center align-items-center">
        <div className="navbar-brand d-flex align-items-start text-nowrap">
          <img
            src={brandLogo}
            width="500"
            alt="logo"
            className="img-fluid me-3"
          />
          {/* <div className="fs-1 Gotham-Black">Infused Analytics</div> */}
        </div>
        <div className="d-grid gap-2 mt-5">
          {/* <button className="btn btn-light mt-5 fs-5 px-5 rounded-0" onClick={()=>navigate("/Register")}>! Sign in to access this site</button> */}
          {/* <button className="btn btn-primary my-2 rounded-0">kryz.novotnaj@hubinternational.com</button> */}
          <form method="POST" action={config.API_URL + Url.SIGNIN_API_URL}>
            <button
              class="rounded-0 fw-bold fs-5 px-4 justify-content-between py-2 d-flex align-items-center"
              type="submit"
              style={{ border: "1px solid grey" }}
            >
              <object
                type="image/svg+xml"
                className="me-3"
                data="https://s3-eu-west-1.amazonaws.com/cdn-testing.web.bas.ac.uk/scratch/bas-style-kit/ms-pictogram/ms-pictogram.svg"
                style={{
                  height: "1.5em",
                  width: "1.5em",
                }}
              ></object>
               <div onClick={()=>localStorage.setItem('provider','Microsoft')}>Sign in with Microsoft</div>
            </button>
          </form>

          {/* <button className="btn btn-primary rounded-0 fw-bold fs-5" onClick={microsoftAuth}>Sign in</button> */}
        </div>
        {/* <div className="d-grid gap-2 mt-5">
          <form method="GET" action={config.API_URL + Url.SIGN_WITH_GOOGLE_URL}>
              <div className="mt-2 col-12">
                <button
                   class="rounded-0 fw-bold fs-5 px-4 justify-content-between py-2 d-flex align-items-center"
                   type="submit"
                   style={{ border: "1px solid grey" }}
                >
                 
                    <div className="me-3"><GoogleIcon /></div>
                    <div style={{marginLeft:10}} onClick={()=>localStorage.setItem('provider','Google')}>Sign in with Google</div>
                
                </button>
              </div>
            </form>

        </div> */}
      </div>
    </>
  );
};

export default Login;